import { render, staticRenderFns } from "./AdvertisersEditModal.vue?vue&type=template&id=a5f1a916&scoped=true"
import script from "./AdvertisersEditModal.vue?vue&type=script&lang=ts"
export * from "./AdvertisersEditModal.vue?vue&type=script&lang=ts"
import style0 from "./AdvertisersEditModal.vue?vue&type=style&index=0&id=a5f1a916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f1a916",
  null
  
)

export default component.exports